<script setup>
import { onBeforeUnmount, watch } from 'vue'
import { useRoute } from 'vue-router'

import { useModalStore } from '@/store/modalStore'

const modalStore = useModalStore()
const route = useRoute()

watch(
  () => route.fullPath,
  () => {
    if (modalStore.isOpen) {
      modalStore.closeModal(false)
    }
  },
  { flush: 'sync' }
)

onBeforeUnmount(() => {
  if (modalStore.isOpen) {
    modalStore.closeModal(false)
  }
})
</script>

<template>
  <v-dialog
    :model-value="modalStore.isOpen"
    :max-width="modalStore.maxWidth"
    :persistent="modalStore.persistent"
    @update:model-value="!$event && modalStore.dismissModal()"
  >
    <component
      :is="modalStore.component"
      v-if="modalStore.component"
      v-bind="modalStore.props"
      class="mx-auto w-100"
      @close-modal="modalStore.closeModal"
    />
  </v-dialog>
</template>
